import { render, staticRenderFns } from "./CouponPreviewModal.vue?vue&type=template&id=788b18c1&scoped=true&"
import script from "./CouponPreviewModal.vue?vue&type=script&lang=js&"
export * from "./CouponPreviewModal.vue?vue&type=script&lang=js&"
import style0 from "./CouponPreviewModal.vue?vue&type=style&index=0&id=788b18c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788b18c1",
  null
  
)

export default component.exports